<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card card-form">
                    <div class="card-header">
                        <div class="pull-left">
                            <h4 class="card-title float-left">{{name}}</h4>
                        </div>
                        <button class="all-btn add-btn pull-right" @click="addAnalog" v-show="balance.periods.length !== 5">Аналог қўшиш</button>
                    </div>
                    <div class="card-body">
                        <div class="row">
                            <div class="col-12 table-responsive">
                              <div class="table-wrapper">
                                <table class="table table-striped comparison-table" :style="`min-width: ${1100 + balance.periods.length * 130}px`">
                                    <tr>
                                        <th class="w-25 text-center">Курсаткичлар номи <br/> Наименование показателя</th>
                                        <th class="w-10 text-center">Сатр коди <br/> Код стр.</th>
                                        <th class="text-center" v-for="(analog, index) in balance.periods" :key="index" style="position: relative" >
                                            <table class="w-100">
                                                <tr>
                                                    <th>
                                                        <!--<i class="fa fa-remove red" v-show="balance.periods.length !== 1"-->
                                                           <!--style="position: absolute;right: 13px;top: 13px;cursor: pointer"-->
                                                           <!--@click="removeAnalog(index)"></i>-->
                                                        Ҳисобот даври <br/> Отчетный период</th>
                                                </tr>
                                                <tr>
                                                    <th colspan="2">Период {{index + 1}}
                                                        <custom-date-picker
                                                                class="form-control"
                                                                format="dd/MM/yyyy"
                                                                v-model="analog.startDate"
                                                                :date="analog.startDate"
                                                                :clear-button="true">
                                                        </custom-date-picker><br/>
                                                        <custom-date-picker
                                                                class="form-control"
                                                                format="dd/MM/yyyy"
                                                                v-model="analog.endDate"
                                                                :date="analog.endDate"
                                                                :clear-button="true">
                                                        </custom-date-picker>
                                                    </th>
                                                </tr>
                                            </table>
                                        </th>
                                    </tr>
                                    <tr class="bold-row">
                                        <td class="w-25 text-center">1</td>
                                        <td class="w-10 text-center">2</td>
                                        <td class="text-center" v-for="(analog, index) in balance.periods" :key="index" style="position: relative">
                                            {{index+3}}
                                        </td>
                                    </tr>
                                    <tr>
                                        <th :colspan="balance.periods.length + 2" class="text-center">I. Узоқ муддатли активлар <br/> I. Долгосрочные активы </th>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошланғич (қайта тиклаш) қиймати (0100, 0300) <br/> Первоначальная (восстановительная) стоимость (0100, 0300)</td>
                                        <td class="w-10 text-center">{{balance['010'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['010'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Эскириш суммаси  (0200) <br/> Сумма износа (0200)</td>
                                        <td class="w-10 text-center">{{balance['011'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['011'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Қолдиқ (баланс) қиймати (сатр. 010 - 011) <br/> Остаточная (балансовая) стоимость (стр. 010-011)</td>
                                        <td class="w-10 text-center">{{balance['012'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['012'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th :colspan="balance.periods.length + 2" class="text-center">Номоддий активлар: <br/> Нематериальные активы:</th>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошланғич қиймати (0400) <br/> Первоначальная стоимость (0400) </td>
                                        <td class="w-10 text-center">{{balance['020'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['020'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Амортизация суммаси (0500) <br/> Сумма амортизации (0500) </td>
                                        <td class="w-10 text-center">{{balance['021'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['021'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Қолдиқ (баланс) қиймати (сатр. 020 - 021) <br/> Остаточная (балансовая) стоимость (стр. 020-021) </td>
                                        <td class="w-10 text-center">{{balance['022'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['022'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли инвестициялар, жами (сатр.040+050+060+070+080), шу жумладан: <br/> Долгосрочные инвестиции, всего (стр.040+050+060+070+080), в том числе: </td>
                                        <td class="w-10 text-center">{{balance['030'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['030'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Қимматли қоғозлар (0610) <br/> Ценные бумаги (0610) </td>
                                        <td class="w-10 text-center">{{balance['040'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['040'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Шўъба хўжалик жамиятларига инвестициялар (0620) <br/> Инвестиции в дочерние хозяйственные общества (0620) </td>
                                        <td class="w-10 text-center">{{balance['050'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['050'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Қарам хўжалик жамиятларига инвестициялар (0630) <br/> Инвестиции в зависимые хозяйственные общества (0630) </td>
                                        <td class="w-10 text-center">{{balance['060'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['060'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Чет эл капитали мавжуд бўлган корхоналарга инвестициялар (0640) <br/> Инвестиции в предприятие с иностранным капиталом (0640)</td>
                                        <td class="w-10 text-center">{{balance['070'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['070'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>

                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа узоқ муддатли инвестициялар (0690) <br/> Прочие долгосрочные инвестиции (0690) </td>
                                        <td class="w-10 text-center">{{balance['080'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['080'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ўрнатиладиган асбоб-ускуналар (0700) <br/> Оборудование к установке (0700) </td>
                                        <td class="w-10 text-center">{{balance['090'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['090'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Капитал қўйилмалар (0800) <br/> Капитальные вложения (0800) </td>
                                        <td class="w-10 text-center">{{balance['100'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['100'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли дебиторлик қарзлари (0910, 0920, 0930, 0940) <br/> Долгосрочная дебиторская задолженность (0910, 0920, 0930, 0940) </td>
                                        <td class="w-10 text-center">{{balance['110'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['110'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Шундан: муддати ўтган <br/> Из нее: просроченная </td>
                                        <td class="w-10 text-center">{{balance['111'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['111'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли кечиктирилган харажатлар (0950, 0960, 0990) <br/> Долгосрочные отсроченные расходы (0950, 0960, 0990) </td>
                                        <td class="w-10 text-center">{{balance['120'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['120'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">I бўлим бўйича жами (сатр. 012+022+030+090+100+110+120) <br/> Итого по разделу I (стр. 012+022+030+090+100+110+120) </td>
                                        <td class="w-10 text-center">{{balance['130'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['130'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th :colspan="balance.periods.length + 2" class="text-center">II. Жорий активлар <br/> II. Текущие активы </th>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Товар-моддий захиралари, жами (сатр.150+160+170+180), шу жумладан: <br/> Товарно-материальные запасы, всего (стр.150+160+170+180), в том числе: </td>
                                        <td class="w-10 text-center">{{balance['140'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['140'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ишлаб чиқариш захиралари (1000, 1100, 1500, 1600) <br/> Производственные запасы (1000, 1100, 1500, 1600) </td>
                                        <td class="w-10 text-center">{{balance['150'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['150'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Тугалланмаган ишлаб чиқариш (2000, 2100, 2300, 2700) <br/> Незавершенное производство (2000, 2100, 2300, 2700) </td>
                                        <td class="w-10 text-center">{{balance['160'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['160'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Тайёр маҳсулот (2800) <br/> Готовая продукция (2800) </td>
                                        <td class="w-10 text-center">{{balance['170'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['170'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Товарлар (2900 дан 2980 нинг айирмаси) <br/> Товары (2900 за минусом 2980) </td>
                                        <td class="w-10 text-center">{{balance['180'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['180'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Келгуси давр харажатлари (3100) <br/> Расходы будущих периодов (3100) </td>
                                        <td class="w-10 text-center">{{balance['190'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['190'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Кечиктирилган харажатлар (3200) <br/> Отсроченные расходы (3200) </td>
                                        <td class="w-10 text-center">{{balance['200'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['200'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Дебиторлар, жами  (сатр.220+240+250+260+270+280+290+300+310) <br/> Дебиторы, всего (стр.220+240+250+260+270+280+290+300+310) </td>
                                        <td class="w-10 text-center">{{balance['210'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['210'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Шундан: муддати ўтган <br/> Из нее: просроченная </td>
                                        <td class="w-10 text-center">{{balance['211'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['211'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Харидор ва буюртмачиларнинг қарзи (4000 дан 4900 нинг айирмаси) <br/> Задолженность покупателей и заказчиков (4000 за минусом 4900) </td>
                                        <td class="w-10 text-center">{{balance['220'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['220'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ажратилган бўлинмаларнинг қарзи (4110) <br/> Задолженность обособленных подразделений (4110) </td>
                                        <td class="w-10 text-center">{{balance['230'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['230'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Шўъба ва қарам хўжалик жамиятларнинг қарзи (4120) <br/> Задолженность дочерних и зависимых хозяйственных обществ (4120) </td>
                                        <td class="w-10 text-center">{{balance['240'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['240'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ходимларга берилган бўнаклар (4200) <br/> Авансы, выданные персоналу (4200) </td>
                                        <td class="w-10 text-center">{{balance['250'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['250'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Мол етказиб берувчилар ва пудратчиларга берилган бўнаклар (4300) <br/> Авансы, выданные поставщикам и подрядчикам (4300) </td>
                                        <td class="w-10 text-center">{{balance['260'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['260'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бюджетга солиқлар ва бошқа мажбурий тўловлар бўйича бўнак тўловлари (4400) <br/> Авансовые платежи по налогам и другим обязательным платежам в бюджет (4400) </td>
                                        <td class="w-10 text-center">{{balance['270'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['270'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Мақсадли давлат жамғармалари ва суғурталар бўйича бўнак тўловлари (4500) <br/> Авансовые платежи в государственные целевые фонды и по страхованию (4500) </td>
                                        <td class="w-10 text-center">{{balance['280'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['280'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Таъсисчиларнинг устав капиталига улушлар бўйича қарзи (4600) <br/> Задолженность учредителей по вкладам в уставный капитал (4600) </td>
                                        <td class="w-10 text-center">{{balance['290'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['290'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ходимларнинг бошқа операциялар бўйича қарзи (4700) <br/> Задолженность персонала по прочим операциям (4700) </td>
                                        <td class="w-10 text-center">{{balance['300'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['300'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа дебиторлик қарзлари (4800) <br/> Прочие дебиторские задолженности (4800) </td>
                                        <td class="w-10 text-center">{{balance['310'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['310'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Пул маблағлари, жами (сатр.330+340+350+360), шу жумладан: <br/> Денежные средства, всего (стр.330+340+350+360), в том числе: </td>
                                        <td class="w-10 text-center">{{balance['320'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['320'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Кассадаги пул маблағлари  (5000) <br/> Денежные средства в кассе (5000) </td>
                                        <td class="w-10 text-center">{{balance['330'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['330'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ҳисоб-китоб счётидаги пул маблағлари  (5100) <br/> Денежные средства на расчетном счете (5100) </td>
                                        <td class="w-10 text-center">{{balance['340'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['340'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Чет эл валютасидаги пул маблағлари (5200) <br/> Денежные средства в иностранной валюте (5200) </td>
                                        <td class="w-10 text-center">{{balance['350'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['350'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа пул маблағлари ва эквивалентлари (5500, 5600, 5700) <br/> Прочие денежные средства и эквиваленты (5500, 5600, 5700) </td>
                                        <td class="w-10 text-center">{{balance['360'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['360'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Қисқа муддатли инвестициялар (5800) <br/> Краткосрочные инвестиции (5800) </td>
                                        <td class="w-10 text-center">{{balance['370'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['370'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа жорий активлар (5900) <br/> Прочие текущие активы (5900)  </td>
                                        <td class="w-10 text-center">{{balance['380'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['380'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">II бўлим бўйича жами (сатр.140+190+200+210+320+370+380) <br/> Итого по разделу II (стр. 140+190+200+210+320+370+380) </td>
                                        <td class="w-10 text-center">{{balance['390'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['390'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Баланс активи бўйича жами (сатр.130+390) <br/> Всего по активу баланса (стр.130+стр.390) </td>
                                        <td class="w-10 text-center">{{balance['400'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['400'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th :colspan="balance.periods.length + 2" class="text-center">I. Ўз маблағлари манбаи <br/> I. Источники собственних средств </th>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Устав капитали (8300) <br/> Уставный капитал (8300)</td>
                                        <td class="w-10 text-center">{{balance['410'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['410'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Қўшилган капитал (8400) <br/> Добавленный капитал (8400)</td>
                                        <td class="w-10 text-center">{{balance['420'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['420'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Резерв капитали (8500) <br/> Резервный капитал (8500)</td>
                                        <td class="w-10 text-center">{{balance['430'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['430'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Сотиб олинган хусусий акциялар (8600) <br/> Выкупленные собственные акции (8600)</td>
                                        <td class="w-10 text-center">{{balance['440'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['440'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Тақсимланмаган фойда (қопланмаган фойда) (8700) <br/> Нераспределенная прибыль (непокритой убыток) (8700)</td>
                                        <td class="w-10 text-center">{{balance['450'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['450'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Мақсадли тушумлар (8800) <br/> Целевые поступления (8800)</td>
                                        <td class="w-10 text-center">{{balance['460'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['460'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Келгуси давр харажатлари ва тўловлари учун захиралар (8900) <br/> Резервы предстоящих расходов и платежей (8900)</td>
                                        <td class="w-10 text-center">{{balance['470'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['470'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">I бўлим бўйича жами (сатр 410+420+430+440+450+460+470) <br/> Итого по разделу I (стр 410+420+430+440+450+460+470)</td>
                                        <td class="w-10 text-center">{{balance['480'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['480'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <th :colspan="balance.periods.length + 2" class="text-center">II. Мажбуриятлар <br/> II. Обязательства </th>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли мажбуриятлар, жами (сатр 510+520+530+540+550+560+570+580+590) <br/> Долгосрочные обязательства, всего (стр 510+520+530+540+550+560+570+580+590)</td>
                                        <td class="w-10 text-center">{{balance['490'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['490'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">шу жумладан: узоқ муддатли кредиторлик қарзлари (сатр.500+520+540+560+590) <br/> в том числе: долгосрочная кредиторская задолженность (стр.500+520+540+560+590) </td>
                                        <td class="w-10 text-center">{{balance['491'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['491'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">шундан: муддати ўтган узоқ муддатли кредиторлик қарзлари <br/> Из нее: просроченная долгосрочная кредиторская задолженность </td>
                                        <td class="w-10 text-center">{{balance['492'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['492'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Мол етказиб берувчилар ва пудратчиларга узоқ муддатли қарз (7000) <br/> Долгосрочная задолженность поставщикам и подрядчикам (7000) </td>
                                        <td class="w-10 text-center">{{balance['500'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['500'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ажратилган бўлинмаларга узоқ муддатли қарз (7110) <br/> Долгосрочная задолженность обособленным подразделениям (7110) </td>
                                        <td class="w-10 text-center">{{balance['510'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['510'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>Шўъба ва қарам хўжалик жамиятларга узоқ муддатли қарз (7120) <br/> Долгосрочная задолженность дочерним и зависимым хозяйственным обществам (7120) </td>
                                        <td class="w-10 text-center">{{balance['520'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['520'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли кечиктирилган даромадлар (7210, 7220, 7230) <br/> Долгосрочные отсроченные  доходы  (7210, 7220, 7230) </td>
                                        <td class="w-10 text-center">{{balance['530'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['530'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Солиқ ва бошқа мажбурий тўловлар бўйича узоқ муддатли кечиктирилган мажбуриятлар (7240) <br/> Долгосрочные отсроченные  обязательства по налогам и другим обязательным платежам (7240) </td>
                                        <td class="w-10 text-center">{{balance['540'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['540'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа узоқ муддатли кечиктирилган мажбуриятлар (7250, 7290) <br/> Прочие долгосрочные отсроченные обязательства (7250, 7290) </td>
                                        <td class="w-10 text-center">{{balance['550'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['550'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Харидорлар ва буюртмачилардан олинган бўнаклар (7300) <br/> Авансы, полученные от покупателей и заказчиков (7300) </td>
                                        <td class="w-10 text-center">{{balance['560'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['560'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли банк кредитлари (7810) <br/> Долгосрочные банковские кредиты (7810) </td>
                                        <td class="w-10 text-center">{{balance['570'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['570'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли қарзлар (7820, 7830, 7840) <br/> Долгосрочные займы  (7820, 7830, 7840) </td>
                                        <td class="w-10 text-center">{{balance['580'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['580'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа узоқ муддатли кредиторлик қарзлар (7900) <br/> Прочие долгосрочные кредиторские задолженности (7900) </td>
                                        <td class="w-10 text-center">{{balance['590'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['590'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Жорий мажбуриятлар, жами (сатр.610+630+640+650+660+670+680+690+700+710+720+730+740+750+760) <br/> Текущие обязательства, всего (стр.610+630+640+650+660+670+680+690+700+710+720+730+740+750+760) </td>
                                        <td class="w-10 text-center">{{balance['600'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['600'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Шу жумладан: жорий кредиторлик қарзлари (сатр.610+630+650+670+680+690+700+710+720+760) <br/> В том числе: текущая кредиторская задолженность (стр.610+630+650+670+680+690+700+710+720+760) </td>
                                        <td class="w-10 text-center">{{balance['601'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['601'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Шундан: муддати ўтган жорий кредиторлик қарзлари <br/> Из нее: просроченная текущая кредиторская задолженность </td>
                                        <td class="w-10 text-center">{{balance['602'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['602'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Мол етказиб берувчилар ва пудратчиларга қарз (6000) <br/> Задолженность поставщикам и подрядчикам (6000) </td>
                                        <td class="w-10 text-center">{{balance['610'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['610'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Ажратилган бўлинмаларга қарз (6110) <br/> Задолженность обособленным подразделениям (6110) </td>
                                        <td class="w-10 text-center">{{balance['620'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['620'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Шўъба ва қарам хўжалик жамиятларга қарз (6120) <br/> Задолженность дочерним и зависимым хозяйственным обществам (6120) </td>
                                        <td class="w-10 text-center">{{balance['630'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['630'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Кечиктирилган даромадлар (6210, 6220, 6230) <br/> Отсроченные доходы (6210, 6220, 6230) </td>
                                        <td class="w-10 text-center">{{balance['640'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['640'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Солиқ ва бошқа мажбурий тўловлар бўйича кечиктирилган мажбуриятлар (6240) <br/> Отсроченные  обязательства по налогам и другим обязательным платежам (6240) </td>
                                        <td class="w-10 text-center">{{balance['650'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['650'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа кечиктирилган мажбуриятлар (6250, 6290) <br/> Прочие отсроченные обязательства (6250, 6290) </td>
                                        <td class="w-10 text-center">{{balance['660'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['660'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Олинган бўнаклар (6300) <br/> Полученные авансы (6300) </td>
                                        <td class="w-10 text-center">{{balance['670'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['670'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бюджетга тўловлар бўйича қарз (6400) <br/> Задолженность по платежам в бюджет (6400) </td>
                                        <td class="w-10 text-center">{{balance['680'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['680'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Суғурталар бўйича қарз (6510) <br/> Задолженность по страхованию (6510) </td>
                                        <td class="w-10 text-center">{{balance['690'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['690'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Мақсадли давлат жамғармаларига тўловлар бўйича қарз (6520) <br/> Задолженность по платежам в государственные целевые фонды (6520) </td>
                                        <td class="w-10 text-center">{{balance['700'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['700'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Таъсисчиларга бўлган қарзлар (6600) <br/> Задолженность учредителям (6600) </td>
                                        <td class="w-10 text-center">{{balance['710'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['710'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Меҳнатга  ҳақ тўлаш бўйича қарз (6700) <br/> Задолженность по оплате труда (6700) </td>
                                        <td class="w-10 text-center">{{balance['720'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['720'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Қисқа муддатли банк кредитлари (6810) <br/> Краткосрочные банковские кредиты (6810) </td>
                                        <td class="w-10 text-center">{{balance['730'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['730'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Қисқа муддатли қарзлар (6820, 6830, 6840) <br/> Краткосрочные займы (6820, 6830, 6840) </td>
                                        <td class="w-10 text-center">{{balance['740'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['740'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Узоқ муддатли мажбуриятларнинг жорий қисми (6950) <br/> Текущая часть долгосрочных обязательств (6950) </td>
                                        <td class="w-10 text-center">{{balance['750'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['750'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Бошқа кредиторлик қарзлар (6950 дан ташқари 6900) <br/> Прочие кредиторские задолженности (6900 кроме 6950) </td>
                                        <td class="w-10 text-center">{{balance['760'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['760'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">II бўлим бўйича жами  (сатр.490+600) <br/> Итого по разделу II  (стр.490+600) </td>
                                        <td class="w-10 text-center">{{balance['770'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['770'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="w-25 text-center">Баланс пассиви бўйича жами (сатр.480+770) <br/> Всего по пассиву баланса (стр.480+770) </td>
                                        <td class="w-10 text-center">{{balance['780'].code}}</td>
                                        <td class="text-center" v-for="(analog, index) in balance['780'].periods" :key="index" style="position: relative">
                                            <numeric-input v-model="analog.value" :precision="2" align="center"/>
                                        </td>
                                    </tr>
                                </table>
                              </div>
                            </div>
                        </div>
                        <div class="row mt-5">
                            <div class="col-12 btns-box">
                                <button class="all-btn delete-btn" @click="cancel" :disabled="processing">{{$t("action.cancel")}}</button>
                                <button class="all-btn add-btn" @click="save" :disabled="processing">{{$t("action.save")}}</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import CustomDatePicker from '@/views/common/CustomDatePicker';

    export default {
        name: "BusinessBalanceView",
        components: {
            CustomDatePicker
        },
        data() {
            return {
                processing: false,
                name: '',
                parentName: ((this.$route.params.hasOwnProperty('parentName') && this.$route.params.parentName) ? ('/' + this.$route.params.parentName + '/') : '/'),
                businessId: ((this.$route.params.hasOwnProperty('id') && this.$route.params.id) ? this.$route.params.id : null),
                balance: {
                    '010': {
                        code: '010',
                        periods: []
                    },
                    '011': {
                        code: '011',
                        periods: []
                    },
                    '012': {
                        code: '012',
                        periods: []
                    },
                    '020': {
                        code: '020',
                        periods: []
                    },
                    '021': {
                        code: '021',
                        periods: []
                    },
                    '022': {
                        code: '022',
                        periods: []
                    },
                    '030': {
                        code: '030',
                        periods: []
                    },
                    '040': {
                        code: '040',
                        periods: []
                    },
                    '050': {
                        code: '050',
                        periods: []
                    },
                    '060': {
                        code: '060',
                        periods: []
                    },
                    '070': {
                        code: '070',
                        periods: []
                    },
                    '080': {
                        code: '080',
                        periods: []
                    },
                    '090': {
                        code: '090',
                        periods: []
                    },
                    '100': {
                        code: '100',
                        periods: []
                    },
                    '110': {
                        code: '110',
                        periods: []
                    },
                    '111': {
                        code: '111',
                        periods: []
                    },
                    '120': {
                        code: '120',
                        periods: []
                    },
                    '130': {
                        code: '130',
                        periods: []
                    },
                    '140': {
                        code: '140',
                        periods: []
                    },
                    '150': {
                        code: '150',
                        periods: []
                    },
                    '160': {
                        code: '160',
                        periods: []
                    },
                    '170': {
                        code: '170',
                        periods: []
                    },
                    '180': {
                        code: '180',
                        periods: []
                    },
                    '190': {
                        code: '190',
                        periods: []
                    },
                    '200': {
                        code: '200',
                        periods: []
                    },
                    '210': {
                        code: '210',
                        periods: []
                    },
                    '211': {
                        code: '211',
                        periods: []
                    },
                    '220': {
                        code: '220',
                        periods: []
                    },
                    '230': {
                        code: '230',
                        periods: []
                    },
                    '240': {
                        code: '240',
                        periods: []
                    },
                    '250': {
                        code: '250',
                        periods: []
                    },
                    '260': {
                        code: '260',
                        periods: []
                    },
                    '270': {
                        code: '270',
                        periods: []
                    },
                    '280': {
                        code: '280',
                        periods: []
                    },
                    '290': {
                        code: '290',
                        periods: []
                    },
                    '300': {
                        code: '300',
                        periods: []
                    },
                    '310': {
                        code: '310',
                        periods: []
                    },
                    '320': {
                        code: '320',
                        periods: []
                    },
                    '330': {
                        code: '330',
                        periods: []
                    },
                    '340': {
                        code: '340',
                        periods: []
                    },
                    '350': {
                        code: '350',
                        periods: []
                    },
                    '360': {
                        code: '360',
                        periods: []
                    },
                    '370': {
                        code: '370',
                        periods: []
                    },
                    '380': {
                        code: '380',
                        periods: []
                    },
                    '390': {
                        code: '390',
                        periods: []
                    },
                    '400': {
                        code: '400',
                        periods: []
                    },
                    '410': {
                        code: '410',
                        periods: []
                    },
                    '420': {
                        code: '420',
                        periods: []
                    },
                    '430': {
                        code: '430',
                        periods: []
                    },
                    '440': {
                        code: '440',
                        periods: []
                    },
                    '450': {
                        code: '450',
                        periods: []
                    },
                    '460': {
                        code: '460',
                        periods: []
                    },
                    '470': {
                        code: '470',
                        periods: []
                    },
                    '480': {
                        code: '480',
                        periods: []
                    },
                    '490': {
                        code: '490',
                        periods: []
                    },
                    '491': {
                        code: '491',
                        periods: []
                    },
                    '492': {
                        code: '492',
                        periods: []
                    },
                    '500': {
                        code: '500',
                        periods: []
                    },
                    '510': {
                        code: '510',
                        periods: []
                    },
                    '520': {
                        code: '520',
                        periods: []
                    },
                    '530': {
                        code: '530',
                        periods: []
                    },
                    '540': {
                        code: '540',
                        periods: []
                    },
                    '550': {
                        code: '550',
                        periods: []
                    },
                    '560': {
                        code: '560',
                        periods: []
                    },
                    '570': {
                        code: '570',
                        periods: []
                    },
                    '580': {
                        code: '580',
                        periods: []
                    },
                    '590': {
                        code: '590',
                        periods: []
                    },
                    '600': {
                        code: '600',
                        periods: []
                    },
                    '601': {
                        code: '601',
                        periods: []
                    },
                    '602': {
                        code: '602',
                        periods: []
                    },
                    '610': {
                        code: '610',
                        periods: []
                    },
                    '620': {
                        code: '620',
                        periods: []
                    },
                    '630': {
                        code: '630',
                        periods: []
                    },
                    '640': {
                        code: '640',
                        periods: []
                    },
                    '650': {
                        code: '650',
                        periods: []
                    },
                    '660': {
                        code: '660',
                        periods: []
                    },
                    '670': {
                        code: '670',
                        periods: []
                    },
                    '680': {
                        code: '680',
                        periods: []
                    },
                    '690': {
                        code: '690',
                        periods: []
                    },
                    '700': {
                        code: '700',
                        periods: []
                    },
                    '710': {
                        code: '710',
                        periods: []
                    },
                    '720': {
                        code: '720',
                        periods: []
                    },
                    '730': {
                        code: '730',
                        periods: []
                    },
                    '740': {
                        code: '740',
                        periods: []
                    },
                    '750': {
                        code: '750',
                        periods: []
                    },
                    '760': {
                        code: '760',
                        periods: []
                    },
                    '770': {
                        code: '770',
                        periods: []
                    },
                    '780': {
                        code: '780',
                        periods: []
                    },
                    businessId: this.businessId,
                    periods: [],
                    data: {

                    }
                }
            }
        },
        validations() {
            return {

            }
        },
        computed: {
        },
        methods: {
            init() {
                const vm = this;
                this.$http.get('asset/balance/' + this.businessId)
                    .then(res => {
                        if (res.data.data) {
                            for (const key in res.data.data) {
                                vm.balance[key].periods = res.data.data[key];
                            }
                            vm.balance.periods = res.data.periods;
                        } else {
                            this.addAnalog();
                        }

                    }, err => {
                        console.log(err);
                    });
            },
            cancel() {
                this.$router.push(this.parentName + 'real-estate/edit/' + this.realEstateId);
            },
            save() {
                this.$v.$touch();
                if (this.$v.$invalid) {
                    return;
                }

                this.balance.businessId = this.businessId;
                let periods_columns = [];
                this.balance.periods.forEach((field) => {
                    periods_columns.push({
                        startDate: field.startDate,
                        endDate: field.endDate,
                    });
                });

                this.balance.periods = periods_columns;
                for (let key in this.balance) {
                    if (!(key === "businessId" || key === "periods" || key === "data")) {
                        this.balance.data[key] = this.balance[key].periods;
                    }
                }

                this.processing = true;

                this.$http.post('asset/save-balance', this.balance)
                    .then(res => {
                        console.log(res.data);
                        this.$router.push(this.parentName + 'business/edit/' + this.businessId);
                        this.processing = false;
                    }, err => {
                        this.processing = false;
                        console.log(err);
                    });

                this.processing = true;
            },
            addAnalog() {
                if (this.balance.periods.length === 5)
                    return;

                for (let key in this.balance) {
                    if (key !== "periods" && key !== "businessId" && key !== "data") {
                        this.balance[key].periods.push({
                            index: this.balance[key].periods.length,
                            value: 0
                        });
                    }
                }

                if (!this.balance.periods){
                    this.balance.periods = [];
                }

                this.balance.periods.push({
                    starDate: null,
                    endDate: null,
                });
            },
            removeAnalog(index) {
                if (this.balance.periods.length === 1)
                    return;

                for (let key in this.balance) {
                    if (key !== "periods" && key !== "businessId" && key !== "data") {
                        this.balance[key].periods.splice(index, 1);
                        let periodIndex = 0;
                        this.balance[key].periods.forEach((field) => {
                            field.index = periodIndex;
                            periodIndex++;
                        });
                    }
                }
                this.balance.periods.splice(index, 1);
            }

        },
        created() {
            this.init();
        }
    }
</script>

<style scoped>
    .comparison-table th {
        /*vertical-align: top;*/
        border: 1px solid #dee2e6;
        border-collapse: collapse;
        background-color: #E9FAFD;
    }
    .comparison-table td {
        border: 1px solid #dee2e6;
        border-collapse: collapse;
    }
    .comparison-table .percentage {
        margin: auto;
        width: 110px !important;
        display: inline-block;
    }
    .comparison-table .percentage div {
        width: 80px !important;
        float: left;
    }
    .comparison-table .percentage span {
        display: block;
        margin: 7px 5px;
        float: left;
    }
    .comparison-table .section-start td {
        background-color: #F3F3F3;
    }
    .comparison-table .section-start > td:first-child {
        font-weight: bold;
    }
</style>
